module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "also"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LSO BY")]), _vm._v(" P. J. O’R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURKE")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Modern Manners")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Bachelor Home Companion")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Republican Party Reptile")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Holidays in Hell")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Parliament of Whores")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Give War a Chance")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All the Trouble in the World")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Age and Guile Beat Youth, Innocence, and a Bad Haircut")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Eat the Rich")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The CEO of the Sofa")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Peace Kills")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("On The Wealth of Nations")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Driving Like Crazy")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b33325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/also.vue
// module id = 60
// module chunks = 0